// Components==============
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { faInfo } from '@fortawesome/pro-solid-svg-icons';
import Avatar from 'components/UI/Avatar/Avatar';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import EndpointDescription from 'components/UI/EndpointDescription/EndpointDescription';
import ProjectEvidenceButton from 'components/UI/ProjectEvidenceButton/ProjectEvidenceButton';
import Token from 'components/UI/Token/Token';
import TrainingCard from 'components/UI/TrainingCard/TrainingCard';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useState } from 'react';
import { ChatContext } from '../Chat';
import './SideMenu.module.scss';
// =========================

const Training = ({ id }: { id: number }) => {
  const training = useRedux((state) => state.training?.entities.byId[id]);

  return (
    <div styleName="training">
      <TrainingCard training={training} small withModal />
    </div>
  );
};

const Phase = ({ id }: { id: number }) => {
  const phase = useRedux((state) => state.phase?.entities.byId[id]);

  return <Token token={phase} />;
};

const Activity = ({ id }: { id: number }) => {
  const activity = useRedux((state) => state.activity?.entities.byId[id]);

  return <Token token={activity} />;
};

export default function SideMenu() {
  const { activeChannel } = useContext(ChatContext);

  const translate = useTranslate();

  const [isVisible, setIsVisible] = useState(false);

  const process = useRedux((state) =>
    activeChannel.type === 'App\\ProjectProcess'
      ? state.process?.entities.byId?.[activeChannel.id]
      : undefined
  );

  const descriptionObject = process?.description as {
    content?: string;
    note?: string;
  };

  return (
    <>
      <div styleName="toggle">
        <CircleButton
          color="grey-blue"
          onClick={() => setIsVisible((prev) => !prev)}
          icon={isVisible ? faTimes : faInfo}
        />
      </div>
      {isVisible && (
        <div styleName="wrapper">
          {process?.process_type === 'App\\Training' ? (
            <Training id={process.process_id} />
          ) : process?.process_type === 'App\\Phase' ? (
            <Phase id={process.process_id} />
          ) : process?.process_type === 'App\\Activity' ? (
            <Activity id={process.process_id} />
          ) : activeChannel.member ? (
            <div styleName="img">
              <Avatar user={activeChannel.member} size="big" span />
            </div>
          ) : (
            <img
              src={activeChannel?.image}
              alt={activeChannel?.name}
              styleName="img"
            />
          )}
          {!process && <p styleName="name">{activeChannel?.name}</p>}
          {typeof process?.description === 'string' && process.description && (
            <div styleName="explanation">
              <strong>{translate('general.terms.explanation')}</strong>
              <p>{process?.description}</p>
            </div>
          )}
          {!!descriptionObject?.content && (
            <div styleName="explanation">
              <strong>{translate('general.terms.explanation')}</strong>
              <p>{descriptionObject?.content}</p>
            </div>
          )}
          {!!(
            typeof process?.description === 'object' &&
            'note' in process?.description
          ) && (
            <EndpointDescription description={process?.description} readOnly />
          )}
          {!!process && (
            <ProjectEvidenceButton process={process} limitButtons />
          )}
        </div>
      )}
    </>
  );
}
